var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInquiresaveicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 14.9635V13.408C11.1172 11.9414 11.1172 11.2081 10.6616 10.7525C10.2059 10.2969 9.47265 10.2969 8.00608 10.2969H7.2283C5.76171 10.2969 5.02841 10.2969 4.5728 10.7525C4.11719 11.2081 4.11719 11.9414 4.11719 13.408V14.9635",
    stroke: "#222222",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11719 4.9375H8.00608",
    stroke: "#F37807",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.66667C1 3.46678 1 2.36684 1.68342 1.68342C2.36684 1 3.46678 1 5.66667 1H11.2446C11.5625 1 11.7214 1 11.8644 1.0592C12.0073 1.11841 12.1197 1.23081 12.3445 1.45561L14.5444 3.6555C14.7692 3.8803 14.8816 3.9927 14.9408 4.13563C15 4.27857 15 4.43753 15 4.75545V10.3333C15 12.5332 15 13.6331 14.3166 14.3166C13.6331 15 12.5332 15 10.3333 15H5.66667C3.46678 15 2.36684 15 1.68342 14.3166C1 13.6331 1 12.5332 1 10.3333V5.66667Z",
    stroke: "#222222",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiresaveicon);
export default __webpack_public_path__ + "static/media/inquiresaveicon.f3a7bfc93d873ba1ea9f5b704df83f9a.svg";
export { ForwardRef as ReactComponent };